<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('video.videoName')" prop="videoName">
                <a-input v-model="queryParam.videoName" :placeholder="$t('common.input')" allow-clear/>
              </a-form-item>
            </a-col>
<!--            <a-col :md="5" :sm="24">-->
<!--              <a-form-item label="ID" prop="id">-->
<!--                <a-input v-model="queryParam.id" placeholder="请输入" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('video.isRelease')" prop="isRelease">
                <a-select v-model="queryParam.isRelease" :placeholder="$t('common.select')" allow-clear>
                  <a-select-option value="0">{{ $t('common.no') }}</a-select-option>
                  <a-select-option value="1">{{ $t('common.yes') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('video.orderBySort')" prop="orderBySort">
                <a-select v-model="queryParam.orderBySort" :placeholder="$t('common.select')" allow-clear>
                  <a-select-option :value="0">{{ $t('common.no') }}</a-select-option>
                  <a-select-option :value="1">{{ $t('common.yes') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('video.category')" prop="tagIds">
                  <a-select v-model="queryParam.tagIds" :placeholder="$t('common.select')" allow-clear>
                    <a-select-option v-for="(tag,index) in tagList" :key="index" :value="tag.id">
                      {{  currentLang === 'zh-CN' ? tag.tagTitleIn : tag.tagTitleEn}}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('video.tag')" prop="type">
                  <a-select v-model="queryParam.type" :placeholder="$t('common.select')" allow-clear>
                    <a-select-option value="0">{{ $t('video.noTag') }}</a-select-option>
                    <a-select-option value="1">{{ $t('video.new') }}</a-select-option>
                    <a-select-option value="2">{{ $t('video.hot') }}</a-select-option>
                    <a-select-option value="3">{{ $t('video.premiere') }}</a-select-option>
                    <a-select-option value="4">{{ $t('video.exclusive') }}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>

            <a-col :md="!advanced && 5 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('common.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('common.reset') }}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('common.collapse') : $t('common.expand') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>

          </a-row>
        </a-form>
      </div>
      <!-- 操作按钮（按钮 v-hasPermi 已暂时注释，仅保留菜单权限） -->
      <div class="table-operations">
        <!-- v-hasPermi="['video:video:add']" -->
        <a-button type="primary" @click="$refs.createForm.handleAdd()">
          <a-icon type="plus"/>
          {{ $t('common.add') }}
        </a-button>
        <!-- v-hasPermi="['video:video:remove']" -->
        <a-button type="danger" :disabled="multiple" @click="handleDelete">
          <a-icon type="delete"/>
          {{ $t('common.delete') }}
        </a-button>
        <!-- v-hasPermi="['video:video:export']" -->
        <a-button type="primary" @click="handleExport">
          <a-icon type="download" />{{ $t('common.export') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"/>
      </div>
      <!-- 创建/编辑短剧表单组件 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 导入Excel组件 -->
      <import-excel ref="importExcel" @ok="getList"/>
      <!-- 绑定广告表单组件 -->
      <bind-advertisement-form
        ref="bindAdvertisementForm"
        :visible="bindAdvertisementVisible"
        :videoId="currentVideoId"
        @ok="handleBindAdvertisementOk"
        @cancel="handleBindAdvertisementCancel"
        @get-bind-data="handleGetBindData"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :scroll="{ x: 2500 }"
        :bordered="tableBordered"
      >
        <!-- 创建时间格式化显示 -->
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <!-- 封面图显示（支持预览） -->
        <img slot="coverUrl" slot-scope="text, record" style="width: 48px;height: 48px;" :preview="record.coverUrl"
             v-image-preview :src="record.coverUrl">
        <!-- 排序输入框（按回车保存） -->
        <span slot="sort" slot-scope="text, record">
          <a-input-number :min="0" :precision="0" @pressEnter="editSort(record)" @blur="editSort(record)"
                          v-model="record.sort"></a-input-number>
        </span>
        <!-- 热门排序输入框（按回车保存） -->
        <span slot="trendingSort" slot-scope="text, record">
          <a-input-number :min="0" :precision="0" @keyup.enter="editTrendingSort(record)"
                          v-model="record.trendingSort"></a-input-number>
        </span>
        <!-- 是否启用开关 -->
        <span slot="isOpen" slot-scope="text, record">
          <a-switch :checkedChildren="$t('video.enable')" :unCheckedChildren="$t('video.disable')" v-model="record.isOpen == 1"
                    @change="changeIsOpen($event,record)"/>
        </span>
        <!-- 操作列：编辑、剧集管理、演员列表、绑定广告、删除 -->
        <span slot="operation" slot-scope="text, record">
          <a-space :size="8">
            <!-- v-hasPermi="['video:video:edit']" -->
            <a-divider type="vertical" />
            <!-- v-hasPermi="['video:video:edit']" -->
            <a @click="$refs.createForm.handleUpdate(record, undefined)">
              <a-icon type="edit"/>{{ $t('video.edit') }}
            </a>
            <a-divider type="vertical"  />

           <a-dropdown>
              <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                <a-icon type="double-right"/>
                {{ $t('video.more') }}
              </a>
              <a-menu slot="overlay">
                <!-- v-hasPermi="['system:user:resetPwd']" -->
                <a-menu-item>
                  <a @click="$refs.Gather.getLists(record.id)">
                    <a-icon type="search"/>{{ $t('video.episodeManage') }}
                  </a>
                </a-menu-item>
                <!-- v-hasPermi="['system:user:edit']" -->
                <a-menu-item>
                  <a @click="$refs.VideoPerformer.getVideoPerformer(record.id)">
                    <a-icon type="search"/>{{ $t('video.performerList') }}
                  </a>
                </a-menu-item>
<!--                <a-menu-item>-->
<!--                  <a @click="handleBindAdvertisement(record)">-->
<!--                    <a-icon type="link"/>{{ $t('video.bindAdvertisement') }}-->
<!--                  </a>-->
<!--                </a-menu-item>-->
                <!-- v-hasPermi="['system:user:edit']" -->
                <!-- v-hasPermi="['video:video:remove']" -->
                <a-menu-item>
                  <a @click="handleDelete(record)">
                    <a-icon type="delete"/>{{ $t('common.delete') }}
                  </a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </a-space>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => $t('table.total', { total })"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
        :rowKey="(record, index) => index + 1"
      />
    </a-card>
    <gather ref="Gather"></gather>
    <VideoPerformer ref="VideoPerformer"></VideoPerformer>
  </page-header-wrapper>
</template>

<script>
import {pageVideo, editSort, editTrendingSort, delVideo, changeIsOpen} from '@/api/video/video'
import {listTag} from '@/api/video/tag'
import CreateForm from './modules/CreateForm'
import VideoPerformer from './videoPerformer/index'
import Gather from '../gather/index'
import BindAdvertisementForm from './modules/BindAdvertisementForm'
import {tableMixin} from '@/store/table-mixin'
import ImportExcel from './modules/ImportExcel'
import i18nMixin from '@/store/i18n-mixin'
export default {
  name: 'Video',
  components: {
    CreateForm,
    VideoPerformer,
    Gather,
    ImportExcel,
    BindAdvertisementForm
  },
  mixins: [tableMixin,i18nMixin],
  data() {
    return {
      // 短剧列表数据
      list: [],
      // 表格选中行的key数组
      selectedRowKeys: [],
      // 表格选中行的完整数据
      selectedRows: [],
      // 高级搜索展开/收起状态
      advanced: false,
      // 是否禁用单个操作（选中行数不为1时禁用）
      single: true,
      // 是否禁用多个操作（未选中行时禁用）
      multiple: true,
      // 选中行的ID数组
      ids: [],
      // 表格加载状态
      loading: false,
      // 标签列表
      tagList: [],
      // 数据总数
      total: 0,
      // 绑定广告弹窗显示状态
      bindAdvertisementVisible: false,
      // 当前操作的视频ID
      currentVideoId: null,
      // 查询参数
      queryParam: {
        id: null,
        lookNum: null,
        limitNum: null,
        diamondPrice: null,
        goldPrice: null,
        describe: null,
        tagIds: null,
        type: null,
        isRelease: null,
        totalNum: null,
        videoName: null,
        coverUrl: null,
        orderBySort: 0,
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('video.videoName'),
          // dataIndex: 'videoNameIn',
          dataIndex: this.currentLang === 'zh-CN' ? 'videoNameIn' : 'videoNameEn',
          width: 200,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('video.status'),
          dataIndex: 'isOpen',
          width: 100,
          align: 'center',
          scopedSlots: {customRender: 'isOpen'}
        },
        {
          title: this.$t('video.sortDesc'),
          dataIndex: 'sort',
          align: 'center',
          width: 120,
          scopedSlots: {customRender: 'sort'}
        },
        {
          title: this.$t('video.coverUrlIn'),
          // dataIndex: 'coverUrl',
          dataIndex: this.currentLang === 'zh-CN' ? 'coverUrlIn' : 'coverUrlEn',
          align: 'center',
          width: 120,
          scopedSlots: {customRender: 'coverUrl'}
        },
        {
          title: this.$t('video.totalNum'),
          dataIndex: 'totalNum',
          width: 100,
          align: 'center'
        },
        {
          title: this.$t('video.diamondPrice'),
          dataIndex: 'diamondPrice',
          width: 100,
          align: 'center'
        },
        {
          title: this.$t('video.tag'),
          dataIndex: 'type',
          width: 100,
          align: 'center',
          customRender: (t) => {
            const tagMap = {
              0: this.$t('video.noTag'),
              1: this.$t('video.new'),
              2: this.$t('video.hot'),
              3: this.$t('video.premiere'),
              4: this.$t('video.exclusive')
            }
            return tagMap[t] || this.$t('video.noTag')
          }
        },
        {
          title: this.$t('video.releaseTime'),
          dataIndex: 'releaseTime',
          width: 180,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('video.category'),
          dataIndex: 'tagIds',
          width: 150,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('video.operation'),
          dataIndex: 'operation',
          fixed: 'right',
          width: 200,
          scopedSlots: {customRender: 'operation'},
          align: 'center'
        }
      ]
    }
  },
  created() {
    // 初始化：获取短剧列表和标签列表
    this.getList()
    this.getTagList()
  },
  methods: {
    /**
     * 获取标签列表
     */
    getTagList() {
      listTag().then(response => {
        this.tagList = response.data;
        console.log('进来了问题内容');
        console.log(this.tagList);
      })
    },
    /** 查询短剧列表 */
    getList() {
      this.loading = true
      pageVideo(this.queryParam).then(response => {
        this.list = (response.data.records || []).map(item => {
          item._savedSort = item.sort == null ? 0 : item.sort
          return item
        })
        this.total = Number(response.data.total)
        this.loading = false
      })
    },
    /**
     * 编辑排序（按回车键保存）
     * @param {Object} record - 短剧行数据
     */
    editSort(record) {
      const sort = record.sort == null ? 0 : record.sort
      if (record._savingSort) {
        return
      }
      if (record._savedSort === sort) {
        return
      }
      record._savingSort = true
      editSort({id: record.id, sort}).then(() => {
        record._savedSort = sort
        this.$message.success(this.$t('common.updateSuccess'), 3)
        if (this.queryParam.orderBySort === 1 || this.queryParam.orderBySort === '1') {
          this.getList()
        }
      }).finally(() => {
        record._savingSort = false
      })
    },
    /**
     * 修改启用状态
     * @param {boolean} e - 开关状态
     * @param {Object} record - 短剧行数据
     */
    changeIsOpen(e, record) {
      const isOpen = e ? 1 : 0
      changeIsOpen({id: record.id, isOpen}).then(() => {
        record.isOpen = isOpen
        this.$message.success(this.$t('common.updateSuccess'))
      })
    },
    /**
     * 编辑热门排序（按回车键保存）
     * @param {Object} record - 短剧行数据
     */
    editTrendingSort(record) {
      editTrendingSort({id: record.id, trendingSort: record.trendingSort}).then(() => {
        this.$message.success(this.$t('common.updateSuccess'), 3)
      })
    },
    /**
     * 搜索按钮操作
     */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /**
     * 重置按钮操作
     */
    resetQuery() {
      this.queryParam = {
        id: null,
        lookNum: null,
        limitNum: null,
        diamondPrice: null,
        goldPrice: null,
        describe: null,
        tagIds: null,
        type: null,
        isRelease: null,
        totalNum: null,
        videoName: null,
        coverUrl: null,
        orderBySort: 0,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    /**
     * 分页改变事件
     * @param {number} current - 当前页码
     * @param {number} pageSize - 每页条数
     */
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    /**
     * 表格行选择改变事件
     * @param {Array} selectedRowKeys - 选中的行key数组
     * @param {Array} selectedRows - 选中的行数据数组
     */
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    /**
     * 切换高级搜索展开/收起
     */
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /**
     * 删除短剧
     * @param {Object} row - 短剧行数据（单行删除）或 undefined（批量删除）
     */
    handleDelete(row) {
      const that = this
      // 如果是单行删除，将ID添加到ids数组
      if (row && row.id) {
        this.ids.push(row.id)
      }
      const ids = row && row.id ? row.id : this.ids
      this.$confirm({
        title: this.$t('video.confirmDelete'),
        content: this.$t('video.confirmDeleteContent') + ids,
        onOk() {
          const data = that.ids.map(id => ({ id }))
          return delVideo(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(that.$t('common.deleteSuccess'), 3)
            })
        },
        onCancel() {
          // 取消时不清空ids列表，保持选中状态
        }
      })
    },
    /**
     * 导出短剧数据
     * 导出当前查询条件下的所有数据，而非选中数据
     */
    handleExport() {
      const that = this
      this.$confirm({
        title: this.$t('video.confirmExport'),
        content: this.$t('video.confirmExportContent'),
        onOk() {
          that.download('video/videos/export', {
            ...that.queryParam
          }, `${that.$t('video.exportFileName')}_${new Date().getTime()}.xlsx`)
        },
        onCancel() {}
      })
    },
    /** 绑定广告 */
    handleBindAdvertisement(record) {
      this.currentVideoId = record.id
      this.bindAdvertisementVisible = true
    },
    /**
     * 绑定广告确定回调
     * @param {Object} formData - 绑定广告的表单数据
     */
    handleBindAdvertisementOk(formData) {
      // TODO: 调用绑定接口
      console.log('绑定广告数据:', formData)
      this.$message.success('绑定成功')
    },
    /**
     * 绑定广告取消回调
     */
    handleBindAdvertisementCancel() {
      this.bindAdvertisementVisible = false
      this.currentVideoId = null
    },
    /**
     * 获取绑定数据（已废弃，现在直接在组件内调用）
     * @param {number} videoId - 视频ID
     * @param {Function} callback - 回调函数
     */
    handleGetBindData(videoId, callback) {
      // 此方法已废弃，组件内部直接调用 getGatherList
      callback(null)
    }
  }
}
</script>
